import React, { useState } from 'react';
import { useModal } from '../../../context/ModalContext';
import { FAQS } from '../../../utils/homeData';
import './FAQSection.scss';

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const { openModal } = useModal();

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section className="faq-section">
      <div className="faq-section__inner">
        <div>
          <div className="faq-section__left-eyebrow">DÚVIDAS FREQUENTES</div>
          <h2 className="faq-section__left-title">
            O que todo mundo pergunta antes de assinar.
          </h2>
          <button
            className="faq-section__access-btn"
            onClick={() => openModal('cadastroCliente')}
          >
            QUERO TER ACESSO →
          </button>
        </div>

        <div>
          {FAQS.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.q} className="faq-section__item">
                <button
                  className="faq-section__item-trigger"
                  onClick={() => toggle(index)}
                >
                  <span className={`faq-section__item-symbol${isOpen ? ' faq-section__item-symbol--open' : ''}`}>
                    +
                  </span>
                  <span className="faq-section__item-question">{faq.q}</span>
                </button>
                {isOpen && (
                  <div className="faq-section__item-answer">{faq.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
